import React, { useState , useEffect} from "react";
import classes from "../../style/Style.module.css";
import "../../style/Nriscreens.scss";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { useNavigate } from "react-router-dom";
import { Pincode_Verification, ROUTE_DXTER_SCANNING,
  ROUTE_ACCOUNT_TYPE,Gender_Dob_Verification,
  Address_Verification,
  ROUTE_OCCUPATION,ROUTE_PLACEOF_BIRTH,ROUTE_CHECKBOXES,
  ROUTE_NOMINEE_DETAILS,ROUTE_NOMINEE_SENDOTP,
  ROUTE_NRI_Pincode,ROUTE_NRI_TaxResidency,
  ROUTE_MOBILE_VERIFICATION } from "../../Routes";
  import Toast from "../../Components/ToastMsg/Toast";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "../../libs/axiosConfig";
import { useSelector, useDispatch } from "react-redux";
import { selectPhoneNumber } from "../../Store/MobileSlice";
import { selectPanNumber } from "../../Store/panNumberSlice";
import { updateAddressLine } from "../../Store/dexterrPortfolio/actions";
import NewDexterLogo from "../../Images/NewDexterLogo.svg";
import LogoutModal from "../../Components/LogoutModal";

const TaxIdNumber = () => {
  const dispatch = useDispatch();
  const [IdentityNumber, setIdentityNumber] = useState("");
  const [selectedIdentityType, setSelectedIdentityType] = useState("Passport");
  const [formErrors, setFormErrors] = useState({});
  const [showSuggestions, setShowSuggestions] = useState(false);
  const Navigate = useNavigate();
  const storedToken = useSelector((state) => state.storedToken.accessToken);
  const phoneNumber = useSelector(selectPhoneNumber);
  const [isLoading, setIsLoading] = useState(false);
  const panNumber = useSelector(selectPanNumber);
  const [apiCallsInProgress, setApiCallsInProgress] = useState(3);
  const [showModal, setShowModal] = useState(false);


  useEffect(() => {
    if (apiCallsInProgress > 3) {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
  }, [apiCallsInProgress]);

  const identityTypeMapping = {
    "Passport": "A",
    "Election ID Card": "B",
    "PAN Card": "C",
    "ID Card": "D",
    "Driving License": "E",
    "UIDIA / Aadhar letter": "F",
    "NREGA Job Card": "G",
    "Others": "H",
    "Not categorized": "I",
    "TIN [Tax Payer Identification Number]": "J",
    "Company Identification Number": "K",
    "US GIIN": "L",
    "Global Entity Identification Number": "M"
  };

  const HandleBack = () => {
    setShowModal(true);
  };

  const handleLogoutConfirm = () => {
    Navigate(ROUTE_MOBILE_VERIFICATION);
  };

  const handleClearButtonClick = () => {
    setIdentityNumber("");
    setFormErrors({});
  };

  const handleSubmit = async () => {
    if (!IdentityNumber || !selectedIdentityType) {
      // setFormErrors({
      //   IdentityNumber: !IdentityNumber ? "This field is required" : "",
      //   identityType: !selectedIdentityType ? "This field is required" : "",
      // });
      toast.error("Please fill all the required details");
      return;
    }

    try {
      const headers = {
        Authorization: `Bearer ${storedToken}`,
      };
      setApiCallsInProgress(apiCallsInProgress + 1);
      const requestBody = {
        CustomerKycDetails: {
          request_type: "post",
          mobileNumber: phoneNumber,
          country_code: "+91",
          pan: panNumber,
          nseNriTaxPayerIdentityno1: IdentityNumber,
          nseNriId1Type: identityTypeMapping[selectedIdentityType],
        },
      };

      const fullAddressValue = `${IdentityNumber}`;
      dispatch(updateAddressLine(fullAddressValue));

      const response = await axios.post(
        "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
        requestBody,
        { headers }
      );

      const secondRequestBody = {
        nseNriTaxPayerIdentityno1: IdentityNumber,
        nseNriId1Type: selectedIdentityType,
      };
      if (response.status === 200) {
        setApiCallsInProgress(apiCallsInProgress + 1);
        console.log("2")
        // Toast.success("Second API call successful", "success");

        // Only make the third API call if the first two are successful
        const thirdApiResponse = await axios.post(
          "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
          {
            CustomerKycDetails: {
              request_type: "get",
              mobileNumber: phoneNumber,
              pan: panNumber,
            },
          },
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
              // RefreshToken: refreshToken
            },
          }
        );

        // const customerKycApiResponse = await axios.get(
        //   "https://partnerapp.ambrela.money/api/GetCustomerKycDetails",

        //   {
        //     headers: {
        //       Authorization: `Bearer ${storedToken}`,
        //       // RefreshToken: refreshToken,
        //     },
        //   }
        // );

        if (
          thirdApiResponse.data.statusCode === 200 &&
          thirdApiResponse.data.status === true
        ) {
          setApiCallsInProgress(apiCallsInProgress + 1);
          console.log("3")

          if (
            thirdApiResponse.data.body.bankAccountNumber === "" ||
            thirdApiResponse.data.body.bankIfscCode === "" ||
            thirdApiResponse.data.body.bankAccountType === "" ||
            thirdApiResponse.data.body.bankName === "" ||
            thirdApiResponse.data.body.bankBranchName === "" ||
            thirdApiResponse.data.body.bankBranchAddress === "" ||
            thirdApiResponse.data.body.bankCodeNSE === "" ||
            thirdApiResponse.data.body.bankCodeBillDesk === "" ||
            thirdApiResponse.data.body.bankAccountHolderName === ""
          ) {
            Navigate(ROUTE_ACCOUNT_TYPE);
          } else if (
            (thirdApiResponse.data.body.bankAccountNumber !== "" ||
              thirdApiResponse.data.body.bankIfscCode !== "" ||
              thirdApiResponse.data.body.bankAccountType !== "" ||
              thirdApiResponse.data.body.bankName !== "" ||
              thirdApiResponse.data.body.bankBranchName !== "" ||
              thirdApiResponse.data.body.bankBranchAddress !== "" ||
              thirdApiResponse.data.body.bankCodeNSE !== "" ||
              thirdApiResponse.data.body.bankCodeBillDesk !== "" ||
              thirdApiResponse.data.body.bankAccountHolderName !== "" ||
              null) &&
            (thirdApiResponse.data.body.bankVerified.account_exists !==
              "True" ||
              thirdApiResponse.data.body.bankVerified.message !== "success")
          ) {
            Navigate(ROUTE_ACCOUNT_TYPE);
          } else if (
            thirdApiResponse.data.body.panDetails.gender === "" ||
            thirdApiResponse.data.body.panDetails.title === "" ||
            thirdApiResponse.data.body.panDetails.dob === ""
          ) {
            Navigate(Gender_Dob_Verification);
          } else if (
            thirdApiResponse.data.body.panDetails.addr1 === "" ||
            thirdApiResponse.data.body.panDetails.addr2 === "" ||
            thirdApiResponse.data.body.panDetails.city === "" ||
            thirdApiResponse.data.body.panDetails.state === "" ||
            thirdApiResponse.data.body.panDetails.pincode === "" ||
            thirdApiResponse.data.body.panDetails.country === "" ||
            thirdApiResponse.data.body.panDetails.fullAddress === ""
          ) {
            Navigate(Address_Verification);
          } else if (
            thirdApiResponse.data.body.nseIncomeCode === "" ||
            thirdApiResponse.data.body.nseIncomeCodeDescription === "" ||
            null ||
            thirdApiResponse.data.body.nseOccupationCode === "" ||
            thirdApiResponse.data.body.nseOccupationCodeDescription === "" ||
            null
          ) {
            Navigate(ROUTE_OCCUPATION);
          } else if (
            thirdApiResponse.data.body.placeOfBirth === "" ||
            thirdApiResponse.data.body.nseCountryCodeOfBirth === "" ||
            thirdApiResponse.data.body.nseCountryOfBirth === ""
          ) {
            Navigate(ROUTE_PLACEOF_BIRTH);
          } else if (
            thirdApiResponse.data.body.politicallyExposedPerson === "" ||
            thirdApiResponse.data.body.relatedToPoliticallyExposedPerson === ""
          ) {
            Navigate(ROUTE_CHECKBOXES);
          } else if (
            thirdApiResponse.data.body.nomineeDob !== "" &&
            thirdApiResponse.data.body.nomineeName === ""
          ) {
            Navigate(ROUTE_NOMINEE_DETAILS);
          } else if (
            thirdApiResponse.data.body.nomineeName !== "" &&
            thirdApiResponse.data.body.nomineeDob === ""
          ) {
            Navigate(ROUTE_NOMINEE_DETAILS);
          } else if (
            thirdApiResponse.data.body.nomineeName !== "" &&
            thirdApiResponse.data.body.nomineeType !== "" &&
            thirdApiResponse.data.body.nomineeRelationShip !== "" &&
            thirdApiResponse.data.body.nomineeDob !== "" &&
            thirdApiResponse.data.body.nomineeVerified === "N"
          ) {
            console.log("first");
            Navigate(ROUTE_NOMINEE_SENDOTP);
          }
          else if (
            thirdApiResponse.data.body.nseNriZip === "" &&
            thirdApiResponse.data.body.nseNriCity === "" &&
            thirdApiResponse.data.body.nseNriState === "" &&
            thirdApiResponse.data.body.nseNriCountry === "" 
          ) {
            
            Navigate(ROUTE_NRI_Pincode);
          }
          else if (
            thirdApiResponse.data.body.nseTaxStatusCode === "" &&
            thirdApiResponse.data.body.nseTaxStatusCodeDescription === "" &&
            thirdApiResponse.data.body.nseNriTaxResidencyOtherThanIndia === ""
          ) {
            
            Navigate(ROUTE_NRI_TaxResidency);
          }
         else {
          setApiCallsInProgress(apiCallsInProgress - 1);
          console.log("4")
          Navigate(ROUTE_DXTER_SCANNING)
         }
          
          // Navigate(ROUTE_DXTER_SCANNING)
          console.log("Third API call successful");
          // Toast.success("Third API call successful", "success");
        }
        else {
          console.error("Third API call failed");
          Toast.error(
            thirdApiResponse.data.message +
            "" +
            thirdApiResponse.data.errorMessage
          );
          setApiCallsInProgress(apiCallsInProgress - 1);
        }

      } else {
        console.error("Second API call failed");
        Toast.error(
          response.data.message + " " + response.data.errorMessage
        );
        setApiCallsInProgress(apiCallsInProgress - 1);
      }
     
      setApiCallsInProgress(apiCallsInProgress + 1);
    } catch (error) {
      console.error("Error submitting data:", error);
    }
  };

  const validateInput = (input) => {
    const regex = /^[a-zA-Z0-9\s,.]+$/;
    return regex.test(input);
  };

  const handleInputChange = (e) => {
    const inputValue = e.target.value;
    if (inputValue === "" || validateInput(inputValue)) {
      setIdentityNumber(inputValue);
      setFormErrors({});
    } else {
      setFormErrors({
        IdentityNumber:
          "Only alphabets, numbers, commas, and full stops are allowed",
      });
    }
  };

  const handleSelectChange = (value) => {
    setSelectedIdentityType(value);
    setFormErrors({});
    setShowSuggestions(false);
  };

  const toggleSuggestions = () => {
    setShowSuggestions(!showSuggestions);
  };

  const identityTypes = [
    "Passport",
    "Election ID Card",
    "PAN Card",
    "ID Card",
    "Driving License",
    "UIDIA / Aadhar letter",
    "NREGA Job Card",
    "Others",
    "Not categorized",
    "TIN [Tax Payer Identification Number]",
    "Company Identification Number",
    "US GIIN",
    "Global Entity Identification Number",
  ];

  return (
    <div className="NRI_TaxID_Main_Container">
      <div className="NRI_TaxID_VrifyOtp_Header">
        <ArrowBackIosIcon className="Back_btn" onClick={HandleBack} />
        <div className="NRI_TaxID_Dexter_logo_container">
          <img alt="" src={NewDexterLogo} className="DexterLogo" />
        </div>
      </div>
      <div className="NRI_TaxID_AddressLine_Container">
        <div className="NRI_TaxID_Input_Filed_Box">
          <span className="NRI_TaxID_Enter_mobile_text">
            Tax Payer Identity Number
          </span>
          <div className="NRI_TaxID_Input_Inner_Container">
            <input
              className={`${classes.Input_Filed} ${formErrors.IdentityNumber ? classes.Error : ""
                }`}
              name=" IdentityNumber"
              value={IdentityNumber}
              onChange={handleInputChange}
            />
            <button
              className={classes.Cross_button}
              onClick={handleClearButtonClick}
            />
          </div>
          {formErrors.IdentityNumber && (
            <span className={classes.Error_Message}>
              {formErrors.IdentityNumber}
            </span>
          )}
        </div>

        <div className="NRI_TaxID_Input_Filed_Box2">
          <span className="NRI_TaxID_Enter_mobile_text2">
            Tax Payer Identity Type
          </span>
          <div className="NRI_TaxID_Input_Inner_Container2">
            <input
              className={`${classes.Input_Filed} ${formErrors.identityType ? classes.Error : ""
                }`}
              name="identityType"
              value={selectedIdentityType}
              readOnly
            />
            <button
              className={classes.DropDown_button}
              onClick={toggleSuggestions}
            />
          </div>
          {showSuggestions && (
            <div className={classes.Suggestions_Container}>
              {identityTypes.map((type, index) => (
                <div
                  key={index}
                  className={classes.Suggest_Suggestion}
                  onClick={() => handleSelectChange(type)}
                >
                  {type}
                </div>
              ))}
            </div>
          )}
          {formErrors.identityType && (
            <span className={classes.Error_Message}>
              {formErrors.identityType}
            </span>
          )}
        </div>

        <button className="Submit_button" onClick={handleSubmit}>
          Submit
        </button>
      </div>
      {isLoading && (
        <div className={classes.overlay}>
          <div className={classes.loading_text}>Please Wait...</div>
        </div>
      )}
      <ToastContainer />
      <LogoutModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        onConfirm={handleLogoutConfirm}
      />
    </div>
  );
};

export default TaxIdNumber;
